import { apiJson } from './client';
import { CalendarEvent } from '../calendar/calendarTypes';

export type EventsResponse = {
    success: boolean;
    events: CalendarEvent[];
};

export type EventResponsePayload = {
    response: 'yes' | 'maybe' | 'no';
    note?: string;
};

export type EventResponseResult = {
    success: boolean;
    response?: {
        event_id: string;
        user_id: number;
        response: 'yes' | 'maybe' | 'no';
        note: string | null;
    };
    message?: string;
};

export async function loadEvents(
    apiBaseUrl: string,
): Promise<CalendarEvent[]> {
    const response = await apiJson<EventsResponse>(
        apiBaseUrl,
        '/events',
    );

    return response.events ?? [];
}

export async function loadEventsForCalendar(
    apiBaseUrl: string,
    calendarSlug: string,
): Promise<CalendarEvent[]> {
    const response = await apiJson<EventsResponse>(
        apiBaseUrl,
        `/events?calendar=${encodeURIComponent(calendarSlug)}`,
    );

    return response.events ?? [];
}

export async function sendEventResponse(
    apiBaseUrl: string,
    eventId: string,
    payload: EventResponsePayload,
): Promise<EventResponseResult> {
    return apiJson<EventResponseResult>(
        apiBaseUrl,
        `/events/${encodeURIComponent(eventId)}/response`,
        {
            method: 'POST',
            body: JSON.stringify(payload),
        },
    );
}